<template>
  <div>
      <div class="text-center" style="margin-bottom: 5%;">
        <div class="qrCode">
          <div class="" id="weixinQrCode" style="text-align: center">
            <div >
              <iframe :src="codeUrl" frameborder="0" scrolling="no" width="200px" height="185px">
              </iframe>
            </div>
          </div>
        </div>
        <div class="mt-2" style="text-align: center;">
         <!-- <i class=" iconfont fab fa-weixin me-1 icon-weixin" style="color:#00B500;"></i>-->
          <span style="color: #fea702;font-size: 14px;">
          请使用微信扫一扫登录
          </span>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: "CodeWxLogin",
  data(){
    return {
      //codeUrl:'https://open.weixin.qq.com/connect/qrconnect?appid=wxd8936345ec1df5ac&scope=snsapi_login&redirect_uri=https://segmentfault.com/user/oauth/weixin&state=&login_type=jssdk&self_redirect=default&styletype=&sizetype=&bgcolor=&rst=&href=https://s.segmentfault.com/css/weixin.css',
      codeUrl:'https://open.weixin.qq.com/connect/qrconnect?appid=wx1cf46a153567809a&scope=snsapi_login&redirect_uri=https://xiadan.yongxintao.com/wxlogin/oauth&state=&login_type=jssdk&self_redirect=default&styletype=&sizetype=&bgcolor=&rst=&href=https://server-order-api.yongxintao.com/static/css/weixin.css',
    }
  },
}
</script>

<style scoped>

.impowerBox .qrcode {
  width: 160px;
  height: 160px;
  margin-top: 0;
  border: 1;
}
.impowerBox .title {
  display: none;
}
.impowerBox .info {
  display: none;
}
.status_icon {
  display: none;
}
.impowerBox .status {
  text-align: center;
}

/*.qrCode{
  width: 120px;
}*/
</style>
